import React, { useState, useEffect, useRef, Suspense, useCallback, } from "react";
import "./App.css";
import DateImage from './DateImage';
import Modal from './Modal'; // Import your Modal component
import DateImageModal from './date-image-modal'
import LazyFileViewer from './file-viewer';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import closeIcon from './icons/close (1).png';
import pdfIcon from './icons/pdf.png';
import pptIcon from './icons/ppt.png';
import docIcon from './icons/doc.png';
import mp4Icon from './icons/mp4-file.png';
import mp3Icon from './icons/mp3.png';
import psdIcon from './icons/photoshop.png';
import csvIcon from './icons/csv.png';
import movIcon from './icons/mov.png';
import defaultIcon from './icons/word.png';
import xlsIcon from './icons/xls.png';
import heicIcon from './icons/heic.png'
import ReactVideoPlayer from './react-player';
import HeicViewer from "./heic-viewer";
import download from "./icons/cloud-download.png";
import ADownload from "./icons/cloud-download (1).png"
import loaderIcon from "./icons/loader (2).png";
import modalloader from "./icons/loader (1).png"
import Share from "./icons/share.png";
import { saveAs } from 'file-saver';
import CSVViewer from './renderCSVPreview'; // Import the CSVViewer component
import { useInView } from 'react-intersection-observer';
import {
  fetchPost,
  fetchlogo,
  same,
} from "./apiFolder/index";
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  EmailShareButton,
  EmailIcon,
  LinkedinIcon,
  FacebookIcon,
  TwitterIcon,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";
import { useLocation } from "react-router-dom";
import { Shimmer } from "react-shimmer";
import { debounce, flatMap } from "lodash";
import DocViewer from 'react-doc-viewer';
export default function App() {
  const viewedPosts = useRef(new Set());
  const visiblePosts = useRef(new Set());
  const [posts, setPosts] = useState([]);
  const [logo, setLogo] = useState([]);
  const [interactions, setInteraction] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [isShareOption, setIsShareOption] = useState(false);
  const [showModalsupport, setShowModalSupport] = useState(false);
  const [postIndex, setPostIndex] = useState(null);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [selectedAttachments, setSelectedAttachments] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [liked, setLiked] = useState(Array(posts.length).fill(false));
  const [likedpop, setLikedpop] = useState(Array(posts.length).fill(false));
  const [help, setHelp] = useState(Array(posts.length).fill(false));
  const [helppop, setHelppop] = useState(Array(posts.length).fill(false));
  const [thumbs, setThumbs] = useState(Array(posts.length).fill(false));
  const [thumbspop, setThumbspop] = useState(Array(posts.length).fill(false));
  const [share, setShare] = useState(Array(posts.length).fill(false));
  const [sharepop, setSharepop] = useState(Array(posts.length).fill(false));
  const [support, setSupport] = useState(Array(posts.length).fill(false));
  const [supportpop, setSupportpop] = useState(Array(posts.length).fill(false));
  const [cardCount, setCardCount] = useState(
    new Array(interactions.length).fill(0)
  );
  const cardRef = useRef(null);
  const [csvData, setCsvData] = useState(null);
  const [lastProcessedIndex, setLastProcessedIndex] = useState(-1);
  const [hasApiHit, setHasApiHit] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);
  const { 0: school_id } = useLocation().pathname.split("/").slice(-1);
  const debouncedUpdateViewCount = debounce(viewIncrement, 200);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [isEndOfScroll, setIsEndOfScroll] = useState(false);
  const [offset, setOffset] = useState(20); // Track offset
  const [loadMore, setLoadMore] = useState(false);
  const [currentAttachmentIndex, setCurrentAttachmentIndex] = useState(0);
  const [showAttachmentModal, setShowAttachmentModal] = useState(false);
  const [showNoAttachmentModal, setShowNoAttachmentModal] = useState(false);
  const [isShareAttachment, setIsShareAttachment] = useState(false);
  const [loadingAttachments, setLoadingAttachments] = useState({});
  const [loadingModal, setLoadingModal] = useState(false);
  const NextArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: 'block', right: '10px' }} // Add your inline styles here
        onClick={onClick}
      />
    );
  }

  const PrevArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: 'block', left: '10px', zIndex: 1 }} // Add your inline styles here
        onClick={onClick}
      />
    );
  }
  const settings = {
    dots: true,
    infinite: false,
    speed: 200,
    slidesToShow: 1,
    centerMode: true,
    centerPadding: '0px',
    width: '466px',
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    appendDots: dots => (
      <div
      >
        <div>
          <ul style={{ margin: "0px" }}> {dots} </ul>
        </div>
      </div>
    ),
    draggable: false, // Enable dragging with mouse/touch
    swipe: false,     // Enable swiping with touch
    touchMove: false, // Enable touch move
  };
  const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];

  const getAttachmentIcon = (attachment) => {
    const extension = attachment.split('.').pop().toLowerCase();
    if (imageExtensions.includes(extension)) {
      return attachment; // Return the image URL if it's an image file
    }
    switch (extension) {
      case 'pdf':
        return pdfIcon;
      case 'ppt':
      case 'pptx':
        return pptIcon;
      case 'mp4':
        return mp4Icon;
      case 'mp3':
        return mp3Icon;
      case 'psd':
        return psdIcon;
      case 'csv':
        return csvIcon;
      case 'mov':
        return movIcon;
      case 'xls':
      case 'xlxs':
        return xlsIcon;
      case 'doc':
      case 'docx':
        return docIcon;
      case 'heic':
        return heicIcon;
      // Add more cases as needed
      default:
        return defaultIcon;
    }
  };

  const currentPost = posts[postIndex];

  const handleAttachmentClick = async (attachment, index) => {
    console.log('idx-----------', attachment, '----', index);
    await fetchAndSetAttachment(attachment);
    setCurrentAttachmentIndex(index);
    setShowAttachmentModal(true);
  };

  const handleNoAttachmentClick = () => {
    setShowNoAttachmentModal(true);
  };

  const fetchAndSetAttachment = async (attachment) => {
    const fileExtension = attachment.split('.').pop().toLowerCase();
    if (fileExtension === 'csv') {
      const response = await fetch(attachment);
      const text = await response.text();
      setCsvData(parseCsv(text));
    } else {
      setCsvData(null); // Clear CSV data if not a CSV file
    }
    setSelectedDocument(attachment);
  };


  const closeModalpreview = () => {
    setSelectedDocument(null);
    setCsvData(null);
    setShowAttachmentModal(false);
    setShowNoAttachmentModal(false);
  };

  const handleNextAttachment = () => {
    if (currentAttachmentIndex === currentPost.attachments.length - 1) {
      // do nothing, as we don't want to go forward from the last index
      return;
    } else {
      const nextIndex = (currentAttachmentIndex + 1) % currentPost.attachments.length;
      console.log('length-----------', currentPost.attachments.length);
      console.log('idx-----------', nextIndex);
      setCurrentAttachmentIndex(nextIndex);
      fetchAndSetAttachment(currentPost.attachments[nextIndex]);
    }
  };


  const handlePreviousAttachment = () => {
    if (currentAttachmentIndex === 0) {
      // do nothing, as we don't want to go backward from the first index
      return;
    } else {
      const prevIndex = (currentAttachmentIndex - 1) % currentPost.attachments.length;
      setCurrentAttachmentIndex(prevIndex);
      fetchAndSetAttachment(currentPost.attachments[prevIndex])
    }
  };



  const parseCsv = (text) => {
    const lines = text.split('\n');
    const headers = lines[0].split(',');
    const data = lines.slice(1).map(line => {
      const values = line.split(',');
      const row = {};
      headers.forEach((header, index) => {
        row[header] = values[index];
      });
      return row;
    });
    return { headers, data };
  };

  const renderFileViewer = () => {
    if (!selectedDocument) return null;

    const fileExtension = selectedDocument.split('.').pop().toLowerCase();

    switch (fileExtension) {
      case 'pdf':
        return <iframe className="file-viewer" src={selectedDocument} type="application/pdf" />;
      case 'doc':
      case 'docx':
        return (
          <iframe className="file-viewer" src={`https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(selectedDocument)}`} title="Document Viewer" />
        );
      case 'ppt':
      case 'pptx':
        return (
          <iframe className="file-viewer" src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(selectedDocument)}`} title="PowerPoint Viewer" />
        );
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif':
      case 'webp':
        return (
          <img className="image" src={selectedDocument} alt="Preview" />
        );
      case 'mp3':
      case 'wav':
        return (
          <audio controls className="file-viewer">
            <source src={selectedDocument} type={`audio/${fileExtension}`} />
            Your browser does not support the audio tag.
          </audio>
        );
      case 'mp4':
      case 'webm':
      case 'mov':
        return (
          <ReactVideoPlayer
            url={selectedDocument}
            autoplay={true}
          />
        );
      case 'xls':
      case 'xlsx':
        // Use Office Online's viewer for Excel files
        return (
          <iframe className="file-viewer" src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(selectedDocument)}`} title="Excel Viewer" />
        );
      case 'heic':
        return (
          <HeicViewer selectedDocument={selectedDocument} />
        );
      case 'psd':
        // Use Pixlr to display PSD files
        return (
          <iframe className="file-viewer" src={`https://pixlr.com/e/?image=${encodeURIComponent(selectedDocument)}`} title="PSD Viewer" />
        );
      case 'csv':
        // Render CSV data in a table
        return (
          <div className="csv-viewer">
            <table>
              <thead>
                <tr>
                  {csvData.headers.map((header, index) => (
                    <th key={index}>{header}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {csvData.data.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    {csvData.headers.map((header, colIndex) => (
                      <td key={colIndex}>{row[header]}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        );
      case 'txt':
        return (
          <embed className="file-viewer" src={selectedDocument} type="text/plain" />
        );
      default:
        // For unsupported file types, trigger a download
        return (
          <div className="unsupported-file">
            <p>File type not supported for preview.</p>
            <a href={selectedDocument} download>
              Download
            </a>
          </div>
        );
    }
  };


    const renderFileViewerSlider = (attachment) => {

      const fileExtension = attachment.split('.').pop().toLowerCase();

      switch (fileExtension) {
        case 'pdf':
          return (
            <Suspense fallback={<div>Loading PDF...</div>}>
              <iframe className="file-viewer1" src={attachment} type="application/pdf" />
            </Suspense>
          );
        case 'doc':
        case 'docx':
          return (
            <Suspense fallback={<div>Loading Word Document...</div>}>
              <iframe
                className="file-viewer1"
                src={`https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(attachment)}`}
                title="Document Viewer"
              />
            </Suspense>
          );
        case 'ppt':
        case 'pptx':
          return (
            <Suspense fallback={<div>Loading PowerPoint...</div>}>
              <iframe
                className="file-viewer1"
                src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(attachment)}`}
                title="PowerPoint Viewer"
              />
            </Suspense>
          );
        case 'jpg':
        case 'jpeg':
        case 'png':
        case 'gif':
        case 'webp':
          return <img className="image1" src={attachment} alt="Preview" loading="lazy" />;
        case 'mp3':
        case 'wav':
          return (
            <audio controls className="file-viewer">
              <source src={attachment} type={`audio/${fileExtension}`} />
              Your browser does not support the audio tag.
            </audio>
          );
        case 'mp4':
        case 'webm':
        case 'mov':
          return <ReactVideoPlayer url={attachment} controls={true} />;
        case 'xls':
        case 'xlsx':
          return (
            <Suspense fallback={<div>Loading Excel Document...</div>}>
              <iframe
                className="file-viewer1"
                src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(attachment)}`}
                title="Excel Viewer"
              />
            </Suspense>
          );
        case 'heic':
          return <HeicViewer selectedDocument={attachment} />;
        case 'psd':
          return (
            <Suspense fallback={<div>Loading PSD...</div>}>
              <iframe
                className="file-viewer1"
                src={`https://pixlr.com/e/?image=${encodeURIComponent(attachment)}`}
                title="PSD Viewer"
              />
            </Suspense>
          );
        case 'txt':
          return <embed className="file-viewer1" src={attachment} type="text/plain" />;
        case 'csv':
          return <CSVViewer attachment={attachment} />;
        default:
          return (
            <div className="unsupported-file-slider">
              <img
                className="attachment-image cursor-pointer"
                src={getAttachmentIcon(attachment)}
                alt="Attachment"
                onError={(e) => {
                  e.target.src = logo.Full_Logo__c;
                }}
              />
            </div>
          );
      }
    };

  const AttachmentModal = ({ showModal, closeModal }) => (
    showModal && (
      <Modal onClose={closeModal}>
        <span
          className={`modal-arrow modal-arrow-left ${currentAttachmentIndex === 0 ? 'disabled' : ''}`}
          onClick={currentAttachmentIndex > 0 ? handlePreviousAttachment : null}
        >
          &#10094;
        </span>
        <div className="modal-preview-div">
          {renderFileViewer()}
        </div>
        <span
          className={`modal-arrow modal-arrow-right ${currentAttachmentIndex === currentPost.attachments.length - 1 ? 'disabled' : ''}`}
          onClick={currentAttachmentIndex < currentPost.attachments.length - 1 ? handleNextAttachment : null}
        >
          &#10095;
        </span>
      </Modal>
    )
  );

  const NoAttachmentModal = ({ showModal, closeModal }) => (
    showModal && (
      <Modal onClose={closeModal}>
        <div className="modal-preview-div">
          <img
            className="image"
            src={logo.Full_Logo__c}
            alt="Empty Attachments"
          />
        </div>
      </Modal>
    )
  );

  const handleDownload = async (attachment) => {
    try {
      // Trigger loader state for the specific attachment
      setLoadingAttachments(prevState => ({
        ...prevState,
        [attachment]: true
      }));

      const fileName = attachment.split('/').pop(); // Extract the file name
      let downloadUrl = attachment;

      // If Safari and PDF, add query param to simulate download
        downloadUrl += (attachment.includes('?') ? '&' : '?') + 'download=true';
        console.log('url------', downloadUrl);

      const response = await fetch(downloadUrl);

      if (!response.ok) {
        throw new Error(`Failed to fetch file: ${response.statusText}`);
      }

      const contentType = response.headers.get('content-type');
      if (contentType.includes('text/html')) {
        throw new Error('Invalid file type detected.');
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName || `attachment_${attachment.id}`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);

    } catch (error) {
      console.error('Download error:', error);
      handleDownloadViaIframe(attachment); // Fallback to iframe method in case of error
    } finally {
      // Stop loader state for the specific attachment
      setLoadingAttachments(prevState => ({
        ...prevState,
        [attachment]: false
      }));
    }
  };

  const handleDownloadViaIframe = (attachment) => {
    // Create a temporary anchor element
    const a = document.createElement('a');
    a.href = attachment;
    a.download = ''; // Provide a filename if needed, e.g., 'myfile.pdf'

    // Append anchor to the body and trigger click
    document.body.appendChild(a);
    a.click();

    // Clean up by removing the anchor element
    document.body.removeChild(a);
  };


  const handleSelectAll = () => {
    if (selectedAttachments.length === currentPost.attachments.length) {
      setSelectedAttachments([]);
    } else {
      setSelectedAttachments(currentPost.attachments);
    }
  };

  const handleAttachmentSelect = (attachment) => {
    setSelectedAttachments((prevSelected) =>
      prevSelected.includes(attachment)
        ? prevSelected.filter((att) => att !== attachment)
        : [...prevSelected, attachment]
    );
  };

  const handleShare = () => {
    setIsShareAttachment(true);
    // logic to share selectedAttachments

  };


  const shareattachment = () => {
    return selectedAttachments.join('\n\n');
  };

  const handleDownloadModal = async () => {
    try {
      console.log('Setting loading state to true...');
      setLoadingModal(true);  // Set loading state to true

      // Delay the start of the download process slightly to allow the UI to re-render
      setTimeout(async () => {
        try {
          console.log('Download started');

          // Download all attachments asynchronously
          await Promise.all(
            selectedAttachments.map(async (attachment) => {
              try {
                const cleanedUrl = attachment.replace(/'/g, '') || `attachment_${attachment.id}`;
                const fileName = cleanedUrl.split('/').pop(); // Extract the file name

                // If Safari and PDF, add query param to simulate download
                let downloadUrl = cleanedUrl;
              
                  downloadUrl += (cleanedUrl.includes('?') ? '&' : '?') + 'download=true';

                console.log(`Downloading: ${fileName}`); // Log each download

                const response = await fetch(downloadUrl);

                if (!response.ok) {
                  throw new Error(`Failed to fetch file: ${response.statusText}`);
                }

                const contentType = response.headers.get('content-type');
                if (contentType.includes('text/html')) {
                  throw new Error('Invalid file type detected.');
                }

                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = fileName || `attachment_${attachment.id}`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
              } catch (error) {
                console.error('Error downloading file:', error); // Log errors
                handleDownloadViaIframe(attachment); // Fallback to iframe method in case of error
              }
            })
          );
        } catch (error) {
          console.error('Error during download process:', error); // General error handling
        } finally {
          console.log('Download process completed');
          setLoadingModal(false); // Set loading state to false
        }
      }, 100); // 100ms delay to ensure the state update triggers a re-render
    } catch (error) {
      console.error('Error initializing download modal:', error);
      setLoadingModal(false);  // Set loading state to false on error
    }

    setSelectedAttachments([]);
  };






  useEffect(() => {
    // if (hasMore) {
    fetchPost(school_id)
      .then((res) => {
        //  console.log("ppppppppppppp", res.data.body.data);
        setPosts([...posts, ...res.data.body.data]);
        // setHasMore(res.data.body.data.length > 0);
        setLoading(false);
        setInteraction(res.data.body.data);
        setLiked(new Array(res.data.body.length).fill(false));
        setHelp(new Array(res.data.body.length).fill(false));
        setThumbs(new Array(res.data.body.length).fill(false));
        setShare(new Array(res.data.body.length).fill(false));
        setSupport(new Array(res.data.body.length).fill(false));
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
    // }

    // Fetch Logo

    fetchlogo(school_id)
      .then((res) => {
        console.log("logo00", res.data.body);
        setLogo(res.data.body);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  //Added code
  const handleScroll = () => {
    const position = cardRef.current.scrollTop;
    const maxScroll = cardRef.current.scrollHeight - cardRef.current.clientHeight;
    const scrollThreshold = 25; // Define your threshold here

    setScrollPosition(position);
    setIsEndOfScroll(position >= maxScroll - scrollThreshold);
    if (position >= maxScroll - scrollThreshold) {
      setLoadMore(true);
      console.log("<<<<<<<<<<<<<<<POSITION>>>>>>>>>>>>>>> END");
    }
    else {
      setLoadMore(false);
      console.log("<<<<<<<<<<<<<<<POSITION>>>>>>>>>>>>>>>", position);
    }
  };


  useEffect(() => {
    if (loadMore) {
      fetchPost(school_id, offset)
        .then((res) => {
          if (res.data.body.data.length > 0) {
            // If new posts are fetched
            setPosts((prevPosts) => [...prevPosts, ...res.data.body.data]);
            setInteraction((prevInteractions) => [...prevInteractions, ...res.data.body.data]);
            setOffset((prevOffset) => prevOffset + 20);
          } else {
            // If no new posts are fetched
            console.log("No new posts fetched.");
          }
        })
        .catch((error) => {
          console.error('Error fetching more data:', error);
        })
        .finally(() => {
          setLoadMore(false);
        });
    }
  }, [loadMore, offset, school_id]);


  const postData = async (notificationId, title, field) => {
    try {
      // console.log("event", event);
      // const notificationId = event;
      const data = {
        Notification_Id__c: notificationId,
        Title__c: title,
        Like__c: "0",
        Thanks__c: "0",
        Share__c: "0",
        Helpful__c: "0",
        Support__c: "0",
        View__c: "0",
        Test_School__c: false,
      };

      if (field === "Like") {
        data.Like__c = "1";
      } else if (field === "Share") {
        data.Share__c = "1";
      } else if (field === "Helpful") {
        data.Helpful__c = "1";
      } else if (field === "Thanks") {
        data.Thanks__c = "1";
      } else if (field === "Support") {
        data.Support__c = "1";
      } else if (field === "view") {
        data.View__c = "1";
      }
      same(data, school_id)
        .then((respost) => {
          console.log("postData", respost);
          // fetchPost(school_id, offset)
          // .then((res) => {
          //     // If new posts are fetched
          //     const newPosts = res.data.body.data;
          //     setInteraction((prevInteractions) => [...prevInteractions, ...newPosts]);
          // })
          // .catch((error) => {
          //   console.error('Error fetching more data:', error);
          // })
        })
        .catch((error) => {
          console.log("error", error);
        });

    } catch (error) {
      console.log(error);
    }
  };

  // Use Effect of Scroliing
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // View Increment useEffect
  useEffect(() => {
    console.log("lastProcessedIndex has been updated:", lastProcessedIndex);
    // viewIncrement();
    debouncedUpdateViewCount()
  }, [debouncedUpdateViewCount, lastProcessedIndex]);

  useEffect(() => {
    const cardElement = cardRef.current;
    if (cardElement) {
      cardElement.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (cardElement) {
        cardElement.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  function viewIncrement() {
    const cardElement = cardRef.current;

    if (cardElement) {
      const childElement = cardElement.querySelector(".card");

      if (childElement) {
        const mainWidth = cardElement.clientWidth;
        const mainHeight = cardElement.clientHeight;
        const scrollTop = cardElement.scrollTop;
        // console.log('77777777777',scrollTop);

        const cardWidth = childElement.clientWidth;
        const cardHeight = childElement.clientHeight;

        const totalCol = Math.floor(mainWidth / cardWidth);
        const totalRow = Math.floor(mainHeight / cardHeight);

        const totalDisplayedItems = totalCol * totalRow;

        const xone = Math.floor(scrollTop / cardHeight);
        const xtwo = cardHeight - xone;
        const xthree = scrollTop - xtwo;

        let startIndex = xone * totalDisplayedItems;
        const endIndex = startIndex + totalDisplayedItems - 1;

        if (scrollTop === 0 && !hasApiHit) {
          setLastProcessedIndex(-1);
          setHasApiHit(true);
        } else if (scrollTop > 0) {
          setHasApiHit(false);
        }
        const isLastCardFullyVisible =
          (scrollTop + mainHeight) >=
          (cardElement.scrollHeight - childElement.clientHeight);
        // if(xthree > cardHeight - 500){
        if (startIndex > lastProcessedIndex || endIndex < lastProcessedIndex) {
          // if (isLastCardFullyVisible && startIndex > lastProcessedIndex) {
          console.log('lastProcessedIndex:', lastProcessedIndex);
          console.log('endIndex', endIndex);
          console.log('startIndex', startIndex);
          if (isLastCardFullyVisible) {
            setLastProcessedIndex(startIndex);
          }

          console.log(
            "start to end",
            startIndex,
            startIndex + totalDisplayedItems
          );
          const newlyVisible = new Set();
          posts
            .slice(startIndex, startIndex + totalDisplayedItems)
            .forEach((post) => {
              let newid = post.id;
              let newschoolId = newid.concat(school_id);
              const uniqueKey = `${newschoolId}_view`;
              newlyVisible.add(uniqueKey);
              // If this post was not visible in the previous scroll, count a view
              if (!visiblePosts.current.has(uniqueKey)) {
                postData(newschoolId, post.title, "view");
              }
            });
          // Update the set of currently visible posts
          visiblePosts.current = newlyVisible;
          // Update lastProcessedIndex after processing the posts
          setLastProcessedIndex(endIndex);
        }
        else if (startIndex <= lastProcessedIndex) {
          console.log(
            "startIndex is less than or equal to lastProcessedIndex. API will not be hit."
          );
        }
      }
    }
  }

  const makeLinksClickable = (text) => {
    const urlPattern = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])|(\bwww\.[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])|(\b[-A-Z0-9+&@#\/%?=~_|!:,.;]+\.[a-z]{2,4}\b(\/[-A-Z0-9+&@#\/%=~_|]*)?)/ig;
    const emailPattern = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi;

    let result = text.replace(urlPattern, (url) => {
      const fullUrl = url.startsWith('http') ? url : `http://${url}`;
      return `<a href="${fullUrl}" target="_blank" class="link-highlight">${url}</a>`;
    });

    result = result.replace(emailPattern, (email) => {
      return `<a href="mailto:${email}" class="link-highlight">${email}</a>`;
    });

    return result;
  };
  const removeSelected = () => {
    setSelectedAttachments([]);
  };

  // modal--------------Startt
  const handleClick = (index) => {
    setShowModal(true);
    setPostIndex(index);
    setImageLoaded(false);
    document.documentElement.style.overflowY = "hidden";
  };
  // Close Modal
  const closeModal = () => {
    setShowModal(false);
    document.documentElement.style.overflowY = "auto";
    setSelectedAttachments([]);
  };
  const handleClickOutside = (e) => {
    // Check if the click event originated from the child modal of showModalsupport modal
    if (showModalsupport && e.target.classList.contains("sharemodal")) {
      closeModalsupport();
    }
    // Check if the click event originated from the child modal of isShareOption modal
    else if (isShareOption && e.target.classList.contains("sharemodal")) {
      closeModalshare();
    }
    // Check if the click event originated from the parent modal, but not the child modal of isShareOption or showModalsupport modal
    else if (
      !showModalsupport &&
      !isShareOption &&
      e.target.classList.contains("modal") &&
      !e.target.classList.contains("sharemodal")
    ) {
      closeModal();
    }
  };
  useEffect(() => {
    if (showModal || isShareOption || showModalsupport) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showModal, isShareOption, showModalsupport]);
  // Modal ---------- End
  // Close Modal of Share
  const closeModalshare = () => {
    console.log("-------------", closeModalshare);
    setIsShareOption(false);
    setIsShareAttachment(false);
    document.body.style.overflow = "auto"; // re-enable background scroll
  };
  const openSupportModel = () => {
    setShowModalSupport(true);
    document.body.style.overflow = "hidden"; // disable background scroll
  };
  const openShareModal = () => {
    setIsShareOption(true);
    document.body.style.overflow = "hidden"; // disable background scroll
  };
  // Close Modal of Share
  const closeModalsupport = () => {
    console.log("-------------", closeModalshare);
    setShowModalSupport(false);
    document.body.style.overflow = "auto"; // re-enable background scroll
  };
  // Crad Share Url
  const shareCard = (index) => {
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);
    url.searchParams.set("index", index);
    return url.toString();
  };

  // COunt INcrement
  const handleClickin = (event, ind) => {
    const countEl = event.target.parentElement.nextSibling;
    const countStr = countEl.innerHTML.trim(); // remove any leading/trailing whitespace
    const count = parseInt(countStr);

    if (!isNaN(count)) {
      console.log("event", count + 1);
      countEl.innerHTML = count + 1;
    }

    setCardCount((prevCardCount) => {
      const newCardCount = [...prevCardCount];
      newCardCount[ind] += 1;
      return newCardCount;
    });
    fetchPost(school_id, offset)
      .then((res) => {
        // If new posts are fetched
        const newPosts = res.data.body.data;
        console.log('///postsss/////', newPosts);
        setInteraction((prevInteractions) => [...prevInteractions, ...newPosts]);
        setOffset((prevOffset) => prevOffset);
      })
      .catch((error) => {
        console.error('Error fetching more data:', error);
      })
  };
  // ── localStorage helpers for like tracking ──
  const getLikedPosts = () => {
    try {
      return JSON.parse(localStorage.getItem(`liked_posts_${school_id}`) || '[]');
    } catch { return []; }
  };
  const isPostLiked = (postId) => getLikedPosts().includes(postId);
  const savePostLiked = (postId) => {
    const likedPosts = getLikedPosts();
    if (!likedPosts.includes(postId)) {
      likedPosts.push(postId);
      localStorage.setItem(`liked_posts_${school_id}`, JSON.stringify(likedPosts));
    }
  };

  // love Button Animation
  const handleLikeClick = useCallback((index) => {
    const postId = posts[index]?.id;
    if (isPostLiked(postId)) return; // Already liked

    savePostLiked(postId);

    const newLiked = [...liked];
    newLiked[index] = true;
    setLiked(newLiked);

    const updatedPosts = [...posts];
    updatedPosts[index].interactions.likes += 1;
    setPosts(updatedPosts);
  }, [posts, liked]);

  const handleLikeClickpopup = (index) => {
    const postId = posts[index]?.id;
    if (isPostLiked(postId)) return; // Already liked

    savePostLiked(postId);

    const newLikedpop = [...likedpop];
    newLikedpop[index] = true;
    setLikedpop(newLikedpop);

    const updatedPosts = [...posts];
    updatedPosts[index].interactions.likes += 1;
    setPosts(updatedPosts);
  };
  // Thumbs-Up buttom
  const handleThumbsClick = (index) => {
    const newLikedState = [...thumbs];
    newLikedState[index] = !newLikedState[index];
    setThumbs(newLikedState);

    const updatedPosts = [...posts];
    updatedPosts[index].interactions.thanks += 1;
    setTimeout(() => {
      newLikedState[index] = false;
      setThumbs(newLikedState);
    },);
    setPosts(updatedPosts);
  };
  const handleThumbsClickpop = (index) => {
    const newLikedStatepop = [...thumbspop];
    newLikedStatepop[index] = !newLikedStatepop[index];
    setThumbspop(newLikedStatepop);

    const updatedPosts = [...posts];
    updatedPosts[index].interactions.thanks += 1;
    setTimeout(() => {
      newLikedStatepop[index] = false;
      setThumbspop(newLikedStatepop);
    },);
    setPosts(updatedPosts);
  };
  // helpfull button
  const handleHelpfulClick = (index) => {
    const newLikedState = [...help];
    newLikedState[index] = !newLikedState[index];
    setHelp(newLikedState);

    const updatedPosts = [...posts];
    updatedPosts[index].interactions.helpful += 1;
    setTimeout(() => {
      newLikedState[index] = false;
      setHelp(newLikedState);
    },);
    setPosts(updatedPosts);
  };
  const handleHelpfulClickpop = (index) => {
    const newLikedStatepop = [...helppop];
    newLikedStatepop[index] = !newLikedStatepop[index];
    setHelppop(newLikedStatepop);

    const updatedPosts = [...posts];
    updatedPosts[index].interactions.helpful += 1;
    setTimeout(() => {
      newLikedStatepop[index] = false;
      setHelppop(newLikedStatepop);
    },);
    setPosts(updatedPosts);
  };
  // Share Button
  const handleShareClick = (index) => {
    const newLikedState = [...share];
    newLikedState[index] = !newLikedState[index];
    setShare(newLikedState);

    const updatedPosts = [...posts];
    updatedPosts[index].interactions.shares += 1;
    setTimeout(() => {
      newLikedState[index] = false;
      setShare(newLikedState);
    });
    setPosts(updatedPosts);
  };
  const handleShareClickpop = (index) => {
    const newLikedStatepop = [...sharepop];
    newLikedStatepop[index] = !newLikedStatepop[index];
    setSharepop(newLikedStatepop);

    const updatedPosts = [...posts];
    updatedPosts[index].interactions.shares += 1;
    setTimeout(() => {
      newLikedStatepop[index] = false;
      setSharepop(newLikedStatepop);
    });
    setPosts(updatedPosts);
  };
  // Support Button
  const handleSupportClick = (index) => {
    const newLikedState = [...support];
    newLikedState[index] = !newLikedState[index];
    setSupport(newLikedState);

    const updatedPosts = [...posts];
    updatedPosts[index].interactions.support += 1;
    setTimeout(() => {
      newLikedState[index] = false;
      setSupport(newLikedState);
    });
    setPosts(updatedPosts);
  };
  const handleSupportClickpop = (index) => {
    const newLikedStatepop = [...supportpop];
    newLikedStatepop[index] = !newLikedStatepop[index];
    setSupportpop(newLikedStatepop);

    const updatedPosts = [...posts];
    updatedPosts[index].interactions.support += 1;
    setTimeout(() => {
      newLikedStatepop[index] = false;
      setSupportpop(newLikedStatepop);
    });
    setPosts(updatedPosts);
  };

  // NUmber Format
  function NumberFormat(number) {
    // console.log ('number',typeof number)
    if (number === 0) {
      return "0";
    }
    const suffixes = ["", "k", "M", "B", "T"];
    const magnitude = Math.floor(Math.log10(number) / 3);
    const divisor = 10 ** (magnitude * 3);
    const suffix = suffixes[magnitude];
    const shortNumber = (number / divisor).toLocaleString(undefined, {
      maximumFractionDigits: 1,
      minimumFractionDigits: 1,
    });

    // console.log('Shorthand number ----------- ', parseInt(shortNumber) + suffix,  suffix);
    return parseFloat(shortNumber) + suffix;
  }
  //Linkify
  // Support Email
  function handleEmailClick(email) {
    window.location.href = `mailto:${email}`;
  }
  // Support Calll
  function handlePhoneClick(phoneNumber) {
    //setPhoneCopySuccess(false); // reset phone copy success state
    window.location.href = `tel:${phoneNumber}`; // initiate phone call
  }

  function handleClickNext() {
    if (postIndex === posts.length - 1) {
      // do nothing, as we don't want to go forward from the last index
      return;
    } else {
      setPostIndex((postIndex + 1) % posts.length);
      setImageLoaded(false);
    }
  }
  function handleClickPrev() {
    if (postIndex === 0) {
      // setPostIndex(posts.length - 1);
      return;
    } else {
      setPostIndex((postIndex - 1) % posts.length);
      setImageLoaded(false);
    }
  }
  // Interactions
  function returnInteraction(post, index) {
    let newid = post.id;
    let newschoolId = "";
    let schoopAppC = school_id;
    newschoolId = newid.concat(schoopAppC);
    const combinedLikes = (post.interactions.likes || 0) + (post.interactions.thanks || 0) + (post.interactions.helpful || 0) + (post.interactions.support || 0);
    return (
      <>
        <div className="news-card__action-row">
            <div className="news-card__action-btn">
              <button
                id="like-button"
                onClick={(event) => {
                  if (!isPostLiked(post.id)) {
                    handleLikeClick(index);
                    postData(
                      newschoolId,
                      post.title,
                      "Like"
                    );
                  }
                  handleClickin(event);
                }}
              >
                {(liked[index] || isPostLiked(post.id)) ? (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={liked[index] ? "likesanimation" : ""}>
                    <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" fill="#F54438"/>
                  </svg>
                ) : (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="HeartAnimation">
                    <path d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z" fill="#F54438"/>
                  </svg>
                )}
              </button>
              <span className="news-card__count">{NumberFormat(combinedLikes)}</span>
            </div>
            <div className="news-card__action-btn">
              <button
                onClick={(event) => {
                  postData(
                    newschoolId,
                    post.title,
                    "Share"
                  );
                  handleShareClick(index);
                  handleClickin(event);
                  openShareModal();
                }}
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="HeartAnimation">
                  <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z" fill="#666"/>
                </svg>
              </button>
              {isShareOption && (
                <div className="modal sharemodal">
                  <div className="modal-content share-card">
                    <span className="Close shareclose" onClick={closeModalshare}>&times;</span>
                    <div className="mb-3.5"><p className="ml-2 font-bold text-base">Share With:</p></div>
                    <div className="d-flex contents ml-2">
                      <FacebookShareButton url={shareCard(index)} className="ml-2"><FacebookIcon /></FacebookShareButton>
                      <TwitterShareButton url={shareCard(index)} className="ml-2"><TwitterIcon /></TwitterShareButton>
                      <WhatsappShareButton url={window.location.href} className="ml-2"><WhatsappIcon /></WhatsappShareButton>
                      <LinkedinShareButton url={window.location.href} className="ml-2"><LinkedinIcon /></LinkedinShareButton>
                      <EmailShareButton className="ml-2" url={shareCard(index)}><EmailIcon /></EmailShareButton>
                    </div>
                  </div>
                </div>
              )}
            </div>
        </div>
      </>
    );
  }
  // Interaction pop-Up
  function returnInteractionPopUp(post, index) {
    let newid = post.id;
    let newschoolId = "";
    let schoopAppC = school_id;
    newschoolId = newid.concat(schoopAppC);
    const combinedLikes = (post.interactions.likes || 0) + (post.interactions.thanks || 0) + (post.interactions.helpful || 0) + (post.interactions.support || 0);
    return (
      <>
        <div className="news-card__action-row" style={{justifyContent: 'center', gap: '20px', padding: '8px 0'}}>
            <div className="news-card__action-btn">
              <button
                id="like-button"
                onClick={(event) => {
                  if (!isPostLiked(post.id)) {
                    handleLikeClickpopup(index);
                    postData(newschoolId, post.title, "Like");
                  }
                  handleClickin(event);
                }}
              >
                {(likedpop[index] || isPostLiked(post.id)) ? (
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={likedpop[index] ? "likesanimation" : ""}>
                    <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" fill="#F54438"/>
                  </svg>
                ) : (
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="HeartAnimation">
                    <path d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z" fill="#F54438"/>
                  </svg>
                )}
              </button>
              <span className="news-card__count" style={{fontSize: '15px'}}>{NumberFormat(combinedLikes)}</span>
            </div>
            <div className="news-card__action-btn">
              <button
                onClick={(event) => {
                  postData(newschoolId, post.title, "Share");
                  handleShareClick(index);
                  handleClickin(event);
                  openShareModal();
                }}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="HeartAnimation">
                  <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z" fill="#666"/>
                </svg>
              </button>
              {isShareOption && (
                <div className="modal sharemodal">
                  <div className="modal-content share-card">
                    <span className="Close shareclose" onClick={closeModalshare}>&times;</span>
                    <div className="mb-3.5"><p className="ml-2 font-bold text-base">Share With:</p></div>
                    <div className="d-flex contents ml-2">
                      <FacebookShareButton url={shareCard(index)} className="ml-2"><FacebookIcon /></FacebookShareButton>
                      <TwitterShareButton url={shareCard(index)} className="ml-2"><TwitterIcon /></TwitterShareButton>
                      <WhatsappShareButton url={window.location.href} className="ml-2"><WhatsappIcon /></WhatsappShareButton>
                      <LinkedinShareButton url={window.location.href} className="ml-2"><LinkedinIcon /></LinkedinShareButton>
                      <EmailShareButton className="ml-2" url={shareCard(index)}><EmailIcon /></EmailShareButton>
                    </div>
                  </div>
                </div>
              )}
            </div>
        </div>
      </>
    );
  }

  return (
    <div style={{
      overflowY: 'hidden',
      height: '100vh'
    }}>
      {loading ? (
        <div className="flex justify-center items-center h-screen" style={{ overflowY: 'hidden' }}>
          <div className="w-9 h-9 border-4 border-t-4 loader-blue rounded-full animate-spin" style={{ overflowY: 'hidden' }}></div>
        </div>
      ) : (
        <div className="" style={{
          overflowY: 'hidden'
        }}
        >
          <div
            className="py-6 px-4 sm:px-6 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3 gap-4"
            style={{
              height: '95vh', // Set the height of the scrollable div
              overflowY: 'scroll', // Enable vertical scrolling
            }}
            id="scroll"
            onScroll={handleScroll}
            ref={cardRef}
          >
            {posts &&
              posts.map((post, index) => (
                <React.Fragment key={index}>
                <article
                  className={`news-card${index === 0 ? ' news-card--featured' : ''}`}
                >
                  <div className="news-card__inner">
                    {/* Media section */}
                    {post.attachments && post.attachments.length > 0 ? (
                      post.attachments.length === 1 ? (
                        <div className="news-card__media" onClick={() => handleClick(index)}>
                          <LazyFileViewer key={index} attachment={post.attachments[0]} />
                          {post.attachments.length > 1 && (
                            <span className="news-card__badge">{post.attachments.length} files</span>
                          )}
                        </div>
                      ) : (
                        <div className="news-card__media">
                          <Slider {...settings} className="attachments-scroll-container">
                            {post.attachments.map((attachment, idx) => (
                              <div className="news-card__slide" key={`${attachment}-${idx}`}>
                                <div className="attachment" onClick={() => handleClick(index)}>
                                  <LazyFileViewer key={index} attachment={attachment} />
                                </div>
                              </div>
                            ))}
                          </Slider>
                        </div>
                      )
                    ) : (
                      <div className="news-card__media news-card__media--placeholder" onClick={() => handleClick(index)}>
                        <img
                          className="news-card__logo-fallback"
                          src={logo.Full_Logo__c}
                          alt=""
                        />
                      </div>
                    )}

                    {/* Content section */}
                    <div className="news-card__body">
                      {post.date && (
                        <time className="news-card__date">
                          {new Date(post.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }).toUpperCase()}
                        </time>
                      )}
                      <h3 className="news-card__title cursor-pointer" onClick={() => handleClick(index)}>{post.title}</h3>
                      <p className="news-card__excerpt cursor-pointer" onClick={() => handleClick(index)}>
                        {post.description}
                      </p>
                      <footer className="news-card__footer">
                        <span className="news-card__views">{post.interactions.views} views</span>
                        <div className="news-card__actions">{returnInteraction(post, index)}</div>
                      </footer>
                    </div>
                  </div>
                </article>
                  {postIndex === index && showModal && (
                        <div className="modal fullcard" onClick={handleClickOutside}>
                          <div className="prevbtn mr-12 sm:mr-1 md:mr-8">
                            <span
                              className="prev-arrow cursor-pointer prevbtn"
                              onClick={handleClickPrev}
                            >
                              &#10094;
                            </span>
                          </div>
                          <div className="modal-content modal-card modal-card-modern xl:w-3/5 lg:w-4/5 md:w-4/5 sm:w-4/5 relative">
                            <div className="modal-close-row">
                              <div className="Close-modal" onClick={closeModal}>
                                <img className="Close-image" src={closeIcon} alt="Close" />
                              </div>
                            </div>
                            <div className="modal-scroll-area">
                              {/* Header: logo, date, title, description */}
                              <div className="modal-header-modern">
                                <div className="modal-header-top">
                                  <div className="logo-modal">
                                    <img className="Logo-image" src={logo.Full_Logo__c} alt="Logo" />
                                  </div>
                                  <time className="modal-date-modern">
                                    {post.date && new Date(post.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }).toUpperCase()}
                                  </time>
                                </div>
                                <h2 className="modal-title-modern">{post.title}</h2>
                                <div
                                  className="modal-desc-modern"
                                  dangerouslySetInnerHTML={{ __html: makeLinksClickable(post.description) }}
                                >
                                </div>
                              </div>

                              {/* Attachments */}
                              <div className="attachments-container-modal">
                                {post.attachments && post.attachments.length > 0 ? (
                                  <>
                                    <div
                                      className={`attachments-grid-container-${post.attachments.length === 1 ? 'center-one' : post.attachments.length === 2 ? 'center-two' : 'modal'}`}
                                    >
                                      {post.attachments.map((attachment, idx) => (
                                        <div className="img-back-modal" key={idx}>
                                          <div className="attachment-modal">
                                            {post.attachments.length > 1 && (
                                              <div className="checkbox-container">
                                                <input
                                                  type="checkbox"
                                                  checked={selectedAttachments.includes(attachment)}
                                                  onChange={() => handleAttachmentSelect(attachment)}
                                                />
                                              </div>
                                            )}
                                            <div
                                              className="cursor-pointer"
                                              onClick={() => handleAttachmentClick(attachment, idx)}
                                            >
                                              <div className="attachment-image-modal" onClick={() => handleAttachmentClick(attachment, idx)}>
                                                {renderFileViewerSlider(attachment)}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                    <div className="attachments-actions-modern">
                                      {post.attachments.length > 1 && (
                                        <button className="attachment-select" onClick={handleSelectAll} style={{
                                          color: logo.Primary_Color__c,
                                        }}>
                                          {selectedAttachments.length === post.attachments.length ? 'Deselect All' : 'Select All'}
                                        </button>
                                      )}
                                      {post.attachments.length === 1 && <div />}
                                      <div className="share-download">
                                        <button
                                          className="attachment-download"
                                          onClick={() => {
                                            if (post.attachments.length === 1) {
                                              handleDownload(post.attachments[0]);
                                            } else {
                                              handleDownloadModal();
                                            }
                                          }}
                                          disabled={post.attachments.length > 1 && selectedAttachments.length === 0}
                                          style={{
                                            marginRight: '8px',
                                            backgroundColor: (post.attachments.length > 1 && selectedAttachments.length === 0) ? '#d3d3d3' : '#e3bc42',
                                          }}
                                        >
                                          Download
                                          {loadingModal ? (
                                            <img src={modalloader} alt="Loading..." className="spinner" />
                                          ) : (
                                            <img src={ADownload} alt="Download" style={{ height: '20px', width: '20px', marginLeft: '8px' }} />
                                          )}
                                        </button>
                                        <button
                                          className="attachment-share"
                                          onClick={() => {
                                            if (post.attachments.length === 1) {
                                              setSelectedAttachments(post.attachments);
                                              setTimeout(() => handleShare(), 0);
                                            } else {
                                              handleShare();
                                            }
                                          }}
                                          disabled={post.attachments.length > 1 && selectedAttachments.length === 0}
                                          style={{
                                            backgroundColor: (post.attachments.length > 1 && selectedAttachments.length === 0) ? '#d3d3d3' : '#3e3e3e',
                                          }}
                                        >
                                          Share
                                          <img src={Share} alt="Share" style={{ height: '18px', width: '18px', marginLeft: '8px' }} />
                                        </button>
                                      </div>
                                    </div>
                                  </>
                                ) : (
                                  <div className="img-back">
                                    <div className="attachment" onClick={handleNoAttachmentClick}>
                                      <img
                                        className="attachment-image cursor-pointer"
                                        src={logo.Full_Logo__c}
                                        alt="Empty Attachments"
                                      />
                                    </div>
                                  </div>
                                )}
                                {isShareAttachment && (
                                  <div className="modal sharemodal">
                                    <div className="modal-content share-card">
                                      <span className="Close shareclose" onClick={closeModalshare}>&times;</span>
                                      <div className="mb-3.5">
                                        <h1 className="ml-2 font-bold text-base">Share With:</h1>
                                      </div>
                                      <div className="d-flex contents ml-2">
                                        <FacebookShareButton url={shareattachment()} className="ml-2"><FacebookIcon /></FacebookShareButton>
                                        <TwitterShareButton url={shareattachment()} className="ml-2"><TwitterIcon /></TwitterShareButton>
                                        <WhatsappShareButton url={shareattachment()} className="ml-2"><WhatsappIcon /></WhatsappShareButton>
                                        <LinkedinShareButton url={shareattachment()} className="ml-2"><LinkedinIcon /></LinkedinShareButton>
                                        <EmailShareButton subject="Check Attachments" url={shareattachment()} className="ml-2"><EmailIcon /></EmailShareButton>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>

                            {/* Sticky footer */}
                            <div className="modal-footer-modern">
                              <span className="modal-views-modern">{post.interactions.views} views</span>
                              <div className="modal-footer-actions">{returnInteractionPopUp(post, index)}</div>
                            </div>
                          </div>
                          <div className="nxtbtn ml-12 sm:ml-1 md:ml-8">
                            <span
                              className="next-arrow cursor-pointer nxtbtn"
                              onClick={handleClickNext}
                            >
                              &#10095;
                            </span>
                          </div>
                        </div>
                      )}
                </React.Fragment>
              ))}
            <AttachmentModal
              showModal={showAttachmentModal}
              closeModal={closeModalpreview}
            />

            <NoAttachmentModal
              showModal={showNoAttachmentModal}
              closeModal={closeModalpreview}
            />
          </div>
        </div>
      )}
      {/* Conditional rendering of loader */}
      {loadMore && (
        <div className="flex justify-center items-center">
          <div className="w-10 h-10 border-4 border-t-4 loader-blue rounded-full animate-spin"></div>
        </div>
      )}
    </div>
  );
}
